import React, { useState, useEffect } from 'react';

import {
  makeStyles,
  Grid,
  Container,
  TextField,
  ThemeProvider,
  createMuiTheme,
  InputAdornment,
  IconButton,
  Link,
} from '@material-ui/core';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Button from '../elements/Button';

import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';
import { loginUser } from '../../actions/authActions';

const useStyles = makeStyles((theme) => ({
  item: {
    paddingTop: 20,
  },
  btn: {
    display: 'flex',
    justifyContent: 'center',
  },
  margin: {
    margin: theme.spacing(1),
  },
  errorText: {
    color: 'red',
  },
}));

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#22788C',
    },
  },
});

const Login = () => {
  // redux variables
  const dispatch = useDispatch();
  const errors = useSelector((state) => state.errors);
  const auth = useSelector((state) => state.auth);

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  let history = useHistory();
  const styles = useStyles();

  const handleClickShowPassword = () => setShowPassword(!showPassword);
  const handleMouseDownPassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    if (auth.isAuthenticated) {
      history.push('/dashboard');
    }
  }, [auth, history]);

  const handleSubmit = () => {
    const user = { email, password };
    dispatch(loginUser(user));
  };

  return (
    <ThemeProvider theme={theme}>
      <Container className={styles.root} maxWidth='sm'>
        <Grid container alignItems='center' justify='center' spacing={2}>
          <Grid item>
            <h2>
              {' '}
              Login <span className='text-color-secondary'>below</span>{' '}
            </h2>
          </Grid>
          <Grid item xs={12} className={styles.item}>
            <TextField
              fullWidth
              label='Email Address'
              value={email}
              variant='outlined'
              onChange={(e) => setEmail(e.target.value)}
              required
              error={errors.email}
              className={classnames('', {
                invalid: errors.email,
              })}
            />
            <span className={styles.errorText}>{errors.email}</span>
          </Grid>
          <Grid item xs={12} className={styles.item}>
            <TextField
              fullWidth
              label='Password'
              value={password}
              type={showPassword ? 'text' : 'password'}
              variant='outlined'
              error={errors.password}
              className={classnames('', {
                invalid: errors.password,
              })}
              onChange={(e) => setPassword(e.target.value)}
              required
              InputProps={{
                endAdornment: (
                  <InputAdornment position='end'>
                    <IconButton
                      aria-label='toggle password visibilty'
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      {showPassword ? <Visibility /> : <VisibilityOff />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
            <span className={styles.errorText}>{errors.password}</span>
          </Grid>
          <Grid item xs={12} className={styles.btn}>
            <Button
              className='button button-secondary button-wide-mobile button-sm'
              onClick={handleSubmit}
            >
              {' '}
              Login{' '}
            </Button>
          </Grid>
          <Grid item xs={12} className={styles.btn}>
            <p>Don't have an account? <Link component="button" variant="body1" onClick={() => {history.push('/register');}}>Register here</Link>
            </p>
          </Grid>
        </Grid>
      </Container>
    </ThemeProvider>
  );
};

export default Login;
